<template>
  <div class="question text_left">
    <title-bar-back
      v-if="this.$route.query.whereFrom !== 'app'"
      :title="$route.query.name"
      @back="back"
    >
      <div class="title_right"></div>
    </title-bar-back>
    <!-- 用户协议 -->
    <user-agreement v-if="$route.query.key == 1" />
    <!-- 隐私政策 -->
    <privacy-policy v-if="$route.query.key == 2" />
  </div>
</template>

<script>
const TitleBarBack = () =>
  import("@/components/TitleBarBack").then(m => m.default || m);
import UserAgreement from "./components/UserAgreement.vue";
import PrivacyPolicy from "./components/PrivacyPolicy.vue";
export default {
  name: "QuestionDetail",
  components: {
    TitleBarBack,
    UserAgreement,
    PrivacyPolicy
  },
  data() {
    return {
      list: {
        a: []
      }
    };
  },
  methods: {
    back() {
      this.$router.back();
    }
  }
};
</script>

<style scoped>
.question {
  /* margin-top: 40px; */
}
.title_right {
  width: 36px;
}
</style>
